import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import {
  PATH_MISSION_DEFAULT,
  PATH_MISSION_SERVICE_USAGES,
  PATH_MISSION_SERVICE_USAGES_EDIT,
  PATH_MISSION_SERVICE_USAGES_EDIT_CUSTOMIZE_ALL,
  PATH_MISSION_SERVICE_USAGES_EDIT_CUSTOMIZE_ONE,
  PATH_MISSION_SERVICE_USAGES_EDIT_DELETE,
  PATH_MISSION_SERVICE_USAGES_EDIT_FLUSH_ALL,
  PATH_MISSION_SERVICE_USAGES_EDIT_FLUSH_ONE,
  PATH_MISSION_SERVICE_USAGES_EDIT_MODIFY,
  PATH_MISSION_SERVICE_USAGES_EDIT_NEW,
  PATH_MISSION_SERVICE_USAGES_EDIT_NEW_IN_GROUP,
  PATH_MISSION_SERVICE_USAGES_EDIT_REORDER,
} from '../../app/constants/paths.constant';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import { Loading } from '../../components/Loading';
import { useBuildPaths } from '../../hooks/useBuildPaths.hook';
import { useMissionContext } from '../../contexts/MissionContext/hooks/useMissionContext.hook';
import { MissionContextStatus } from '../../contexts/MissionContext/types/mission-context.type';
import { useMissionBreadcrumbPaths } from '../../hooks/useMissionBreadcrumbPaths.hook';
import { useMissionSpaceWording } from '../../hooks/useMissionSpaceWording.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { ServiceUsages } from './ServiceUsages';

export const MissionServiceUsagesPage = () => {
  const missionContext = useMissionContext();
  const missionWording = useMissionSpaceWording();
  const missionBreadcrumbPaths = useMissionBreadcrumbPaths();
  const { serviceUsageId } = useParams();

  const { missionId, folderId } = missionContext;

  const { paths: missionPaths } = useBuildPaths(
    {
      default: PATH_MISSION_DEFAULT,
      serviceUsages: PATH_MISSION_SERVICE_USAGES,
    },
    { folderId, missionId },
  );

  const { paths: serviceUsagesPaths } = useBuildPaths(
    {
      consult: PATH_MISSION_SERVICE_USAGES,
      edit: PATH_MISSION_SERVICE_USAGES_EDIT,
      editDelete: PATH_MISSION_SERVICE_USAGES_EDIT_DELETE,
      editFlushAll: PATH_MISSION_SERVICE_USAGES_EDIT_FLUSH_ALL,
      editFlushOne: PATH_MISSION_SERVICE_USAGES_EDIT_FLUSH_ONE,
      editCustomizeAll: PATH_MISSION_SERVICE_USAGES_EDIT_CUSTOMIZE_ALL,
      editCustomizeOne: PATH_MISSION_SERVICE_USAGES_EDIT_CUSTOMIZE_ONE,
      editModify: PATH_MISSION_SERVICE_USAGES_EDIT_MODIFY,
      editNew: PATH_MISSION_SERVICE_USAGES_EDIT_NEW,
      // Built without the group: each group form fills its own.
      editNewInGroup: PATH_MISSION_SERVICE_USAGES_EDIT_NEW_IN_GROUP,
      editReorder: PATH_MISSION_SERVICE_USAGES_EDIT_REORDER,
    },
    { folderId, missionId, serviceUsageId },
  );

  const beforeTitleContent = (
    <>
      <Helmet>
        <title>
          {buildDocumentTitle(
            `Chiffrage ${missionWording.ofName}`,
            missionContext.mission?.code,
          )}
        </title>
      </Helmet>
      <Breadcrumbs
        paths={[
          ...missionBreadcrumbPaths,
          {
            to: missionPaths.serviceUsages,
            label: 'chiffrage',
            key: 'serviceUsages',
          },
        ]}
      />
    </>
  );

  const titleContent = (
    <PageTitle title={`Chiffrage ${missionWording.ofName}`} />
  );

  if (missionContext.status !== MissionContextStatus.Ready) {
    return (
      <>
        <Loading />
        {beforeTitleContent}
        {titleContent}
      </>
    );
  }

  const { mission } = missionContext;

  return (
    <>
      {beforeTitleContent}
      <PageTitle code={mission.code} title={mission.consolidation.title} />
      <ServiceUsages paths={serviceUsagesPaths} />
    </>
  );
};
